export const environment = {
  ENV: 'dit',
  APP: 'sol-playground',
  KEYCLOAK_REALM: 'asm',
  KEYCLOAK_URL: 'https://asm-auth.ditext.outpost24.com/auth',
  KEYCLOAK_CLIENT_ID: 'sol-playground',
};
